import React, { Component } from 'react';
import { 
    TextField
} from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';

class SearchBar extends Component {
    state = { }
    
    findMatch = () => {
        const { list } = this.props;
        let { search } = this.state;

        let filteredID = []
        let filteredValues = []
        let IDList = Object.keys(list)
        let valueList = Object.values(list)

        if(!search){
            this.props.filterList(IDList, valueList)
            return
        }

        search = search.toLocaleLowerCase()

        let fields = Object.keys(valueList[0]);
        let otherIndex = fields.indexOf("other");
        otherIndex > -1 && fields.splice(otherIndex, 1) // delete "other" from list if exist

        IDList.filter(ID => {
            let match = fields.filter(field => ( 
                typeof list[ID][field] === "string" 
                && list[ID][field].toLocaleLowerCase().indexOf(search) > -1  
            ))    
            if (match.length > 0) {
                filteredID.push(ID)
                filteredValues.push(list[ID])
            }
        })
        
        this.props.filterList(filteredID, filteredValues)
        return
    }
    render() {
        return (
            <InputText
                // onChange={this.props.handleChange}
                name={this.props.name || "search"} 
                id={this.props.name || "search"} 
                value={this.props.search} 
                label={this.props.label} 
                placeholder="Rechercher"
                onKeyUp={ (e) => this.findMatch(e.target.value, this.state.selectSearch)}
                onChange={ (e) => this.setState({search: e.target.value})} 
            />
        );
    }
}

export default SearchBar;

// import React, { Component } from 'react';

// class SearchBar extends Component {
//     state = { 
//         search: "",
//         searchClass: "custom-search"
//      }
    
//     findMatch = () => {
//         const { list } = this.props;
//         let { search } = this.state;

//         let filteredID = []
//         let filteredValues = []
//         let IDList = Object.keys(list)
//         let valueList = Object.values(list)

//         if(!search){
//             this.props.filterList(IDList, valueList)
//             return
//         }

//         search = search.toLocaleLowerCase()

//         let fields = Object.keys(valueList[0]);
//         let otherIndex = fields.indexOf("other");
//         otherIndex > -1 && fields.splice(otherIndex, 1) // delete "other" from list if exist

//         IDList.filter(ID => {
//             let match = fields.filter(field => ( 
//                 typeof list[ID][field] === "string" 
//                 && list[ID][field].toLocaleLowerCase().indexOf(search) > -1  
//             ))    
//             if (match.length > 0) {
//                 filteredID.push(ID)
//                 filteredValues.push(list[ID])
//             }
//         })
        
//         this.props.filterList(filteredID, filteredValues)
//         return
//     }
//     render() {
//         return (
//             <input 
//                 className={this.state.searchClass} 
//                 type="text" 
//                 name="search" 
//                 value={this.state.search} 
//                 autoComplete="off"
//                 placeholder="Rechercher " 
//                 onKeyUp={ (e) => this.findMatch(e.target.value, this.state.selectSearch)}
//                 onChange={ (e)=> this.setState({search: e.target.value})} 
//                 onBlur={() => this.setState({
//                     searchClass:"custom-search"
//                 })} 
//                 onFocus={() => this.setState({
//                     searchClass:"custom-search-active"
//                 })} 
//             /> 
//         );
//     }
// }

// export default SearchBar;